import { render, staticRenderFns } from "./SupplierContactDisplayView.vue?vue&type=template&id=ea735e10"
import script from "./SupplierContactDisplayView.vue?vue&type=script&lang=js"
export * from "./SupplierContactDisplayView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports